// declare global {
//   interface Window {
//     webkit?: {
//       messageHandlers?: {
//         startApplePay?: {
//           postMessage: (msg: { amount: number }) => void;
//         };
//       };
//     };
//   }
// }

import { getPriceById } from "@/helpers/storeListings";
import { useBalance } from "@/hooks/useBalance";
import { centsToPrettyDollars } from "@skillscratch/shared-util";
import { useMemo } from "react";


export type ApplePayPageProps = {
  storeListingId: string;
  priceId: string;
  purchaseId: string;
}

export function ApplePayPage({ storeListingId, priceId, purchaseId }: ApplePayPageProps) {
  const [user] = useBalance();

  const price = useMemo(() => {
    return getPriceById(priceId)?.price ?? 0
  }, [priceId]);
  
  const amount = useMemo(() => {
    return price - (user?.balance ?? 0);
  }, [user, price])

  const stringifiedAmount = useMemo(() => {
    return centsToPrettyDollars(amount)
  }, [amount])
  

  const handleApplePay = () => {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    (window.webkit as any)?.messageHandlers?.startApplePay?.postMessage({
        amount,
        storeListingId,
        priceId,
        description: "N/A",
        currency: "usd",
        purchaseId,
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    }, (_: any, error: any) => {
        console.log(error);
    });
  };

  return (
      // biome-ignore lint/a11y/useButtonType: <explanation>
      <button
        onClick={handleApplePay}
        style={{
          fontSize: 18,
          padding: "12px 32px",
          borderRadius: 8,
          background: "black",
          color: "white",
          border: "none",
          cursor: "pointer",
          marginTop: 24,
        }}
      >
        Pay {stringifiedAmount} with  Pay
      </button>
  );
}
